import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=b2efefb6&scoped=true&"
import script from "./PaymentStep.vue?vue&type=script&lang=js&"
export * from "./PaymentStep.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStep.vue?vue&type=style&index=0&id=b2efefb6&prod&scoped=true&lang=css&"
import style1 from "./PaymentStep.vue?vue&type=style&index=1&id=b2efefb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2efefb6",
  null
  
)

export default component.exports